declare var swal: any;
import { Component, OnInit } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CounsellingActivityController, CounsellingPlanController, CounsellingPlanRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, SaveCounsellingActivityRequest, GenericProcPostRequest, GenericParams, FTV, S_Methods } from '../../../../../../../src/app/ncs/models/actor/actor';
import { CounsellingActivityRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbActivityMonitoringModal } from './activitymonitoringmodal/activitymonitoring.modal';
import { NgbEditActivityMonitoringModal } from './activitymonitoringmodal/editactivitymonitoring.modal';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { NgbEditActivityMonitoring2Modal } from './activitymonitoringmodal/editactivitymonitoring2.modal';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
//import { NgbEditActivityMonitoringModal } from './activitymonitoringmodal/editactivitymonitoring.modal';
//import { NgbCounsellingRegistryModal } from './modal/counsellingregistry.modal';
@Component({
  selector: 'app-activitytracking',
  templateUrl: './activitytracking.component.html',
  styleUrls: ['./activitytracking.component.css']
})
export class ActivityTrackingComponent implements OnInit {

  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode: number = 0;
  public diff: number = 0;
  public Add: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsToday: boolean = false;
  public IsDuration: boolean = true;
  public IsExpand: boolean = true;
  public isRequesting: boolean = false;
  public ShowMonitoring: boolean = false;
  public ShowTracking: boolean = true;
  public Showarrow: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;
  SelectedToDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  dateI: NgbDateStruct;
  TodayDate = new Date();
  Datediffer = new Date();


  sub: Subscription;
  CurrentCounsellingActivitiesByTimeController: CounsellingActivitiesByTimeController;
  CurrentCounsellingActivitiesByTimeRequest: CounsellingActivitiesByTimeRequest;
  CurrentEditCounsellingActivityRequest: SaveCounsellingActivityRequest;
  LoadPatients() {
    this.CurrentCounsellingActivitiesByTimeRequest = new CounsellingActivitiesByTimeRequest();
    this.CurrentCounsellingActivitiesByTimeRequest.PlanCode = 0;
    //this.CurrentCounsellingActivitiesByTimeRequest.Branch = 0;
    //this.CurrentCounsellingActivitiesByTimeRequest.ActorCode = 43572;
    this.CurrentCounsellingActivitiesByTimeRequest.ConditionalOperator = 20;
    this.CurrentCounsellingActivitiesByTimeRequest.FromDate = new Date();
    this.CurrentCounsellingActivitiesByTimeRequest.ToDate = new Date();
    this.CurrentCounsellingActivitiesByTimeRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    //this.CurrentCounsellingActivitiesByTimeRequest.IsToday = true;
    //this.CurrentCounsellingActivitiesByTimeRequest.IsDuration = false;
    this.CurrentCounsellingActivitiesByTimeRequest.SearchText = "";
    this.CurrentCounsellingActivitiesByTimeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCounsellingActivitiesByTimeController();
  }
  RefreshPatients(st: string) {
    this.CurrentCounsellingActivitiesByTimeRequest = new CounsellingActivitiesByTimeRequest();
    this.CurrentCounsellingActivitiesByTimeRequest.PlanCode = 0;
    //this.CurrentCounsellingActivitiesByTimeRequest.Branch = 0;
    this.CurrentCounsellingActivitiesByTimeRequest.ConditionalOperator = 20;
    this.CurrentCounsellingActivitiesByTimeRequest.FromDate = new Date();
    this.CurrentCounsellingActivitiesByTimeRequest.ToDate = new Date();
    //this.CurrentCounsellingActivitiesByTimeRequest.IsToday = true;
    //this.CurrentCounsellingActivitiesByTimeRequest.IsDuration = false;
    this.CurrentCounsellingActivitiesByTimeRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentCounsellingActivitiesByTimeRequest.SearchText = st;
    this.CurrentCounsellingActivitiesByTimeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetCounsellingActivitiesByTimeController();
  }
  _GetCounsellingActivitiesByTimeController() {
    this.StartRefreshing();


    this.actorservice.GetCounsellingActivitiesByTimeController(this.CurrentCounsellingActivitiesByTimeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCounsellingActivitiesByTimeController = null;
          this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
          //alert(this.ApiResData.Result);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  _GetCounsellingActivitiesByTimeControllerbydate() {
    this.StartRefreshing();
    //alert(this.CurrentCounsellingActivitiesByTimeRequest.FromDate);
    if (this.CurrentCounsellingActivitiesByTimeRequest.FromDate == null) {
      return;

    }
    else {

    this.actorservice.GetCounsellingActivitiesByTimeController(this.CurrentCounsellingActivitiesByTimeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

            this.CurrentCounsellingActivitiesByTimeController = null;
            this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
            //alert(this.ApiResData.Result);
            //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
            //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
            //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
            this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


        );
    }
  }
  GetCounsellingActivitiesByTimeController() {
    this.StartRefreshing();
    //this.spinner.show();

    this.actorservice.GetCounsellingActivitiesByTimeController(this.CurrentCounsellingActivitiesByTimeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
          this.RefreshPatientsByDate();
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  dataChanged(newobj) {
   
    this.RefreshPatientsByDate();
  }
  RefreshPatientsByDate() {


    this.CurrentCounsellingActivitiesByTimeRequest = new CounsellingActivitiesByTimeRequest();
    this.CurrentCounsellingActivitiesByTimeRequest.PlanCode = 0;
    //this.CurrentCounsellingActivitiesByTimeRequest.Branch = 0;
    this.CurrentCounsellingActivitiesByTimeRequest.ConditionalOperator = 30;
    this.CurrentCounsellingActivitiesByTimeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentCounsellingActivitiesByTimeRequest.ToDate = new Date();
    this.CurrentCounsellingActivitiesByTimeRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    //this.CurrentCounsellingActivitiesByTimeRequest.IsToday = true;
    //this.CurrentCounsellingActivitiesByTimeRequest.IsDuration = false;
    //this.CurrentCounsellingActivitiesByTimeRequest.SearchText = st;
    this.CurrentCounsellingActivitiesByTimeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetCounsellingActivitiesByTimeControllerbydate();

  }

  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice:ActorService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter,
    private route: ActivatedRoute,
    public printService: PrintService,
    private tosterservice: NGXToastrService,
    private loginservice: LoginService) { }
  ngOnInit() {
    //this.RefreshPatientsByDate();
    this.LoadPatients();
    this.CurrentEditCounsellingActivityRequest = new SaveCounsellingActivityRequest;
    this.CurrentEditCounsellingActivityRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 2, day: this.TodayDate.getDate() };
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };


  }
 
 

  ShowList: boolean = true;

  
  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
  
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  Selectedpatient: CounsellingActivitiesByTimeController;
  Open(objCategory: any) {
    var patient: CounsellingActivitiesByTimeController = objCategory;
    if (patient != null) {
      this.Selectedpatient = patient;
      this.ShowMonitoring = true;
      this.ShowTracking = false;
      this.Showarrow = true;
    }
    else {
      this.Selectedpatient = null;
    }
  }
  BackToActivities() {
    this.ShowTracking = true;
    this.ShowMonitoring = false;
    this.Showarrow = false;
  }
  criteriaChange(value: string) {
    this.CurrentCounsellingActivitiesByTimeRequest.FromDate = null;
    this.RefreshPatients(value);
    //if (this.filter != null) {
    //  if (value != '[object Event]') {
    //    this.listFilter = value;
    //    //alert(this.listFilter);
    //    this.pdata = this.filter.transform(this.CurrentResourceIdentificationByDateInfoController,
    //      this.listFilter);
    //  }

    //}
  }
  AddPlan() {
    this.ShowMonitoring = true;
    this.ShowTracking = false;
  }
  edit(l: CounsellingActivitiesByTimeController) {

    this.CurrentEditCounsellingActivityRequest.ActivityDate = l.ActivityDate;
    this.CurrentEditCounsellingActivityRequest.ActivityTime = l.ActivityTime;
    this.CurrentEditCounsellingActivityRequest.FollowupMode = l.FollowupMode;
    this.CurrentEditCounsellingActivityRequest.Followupstatus = l.FollowupStatus;
    this.CurrentEditCounsellingActivityRequest.ActualActivityDate = l.ActualActivityDate;
    this.CurrentEditCounsellingActivityRequest.ActualActivityTime = l.ActualActivityTime;
    this.CurrentEditCounsellingActivityRequest.Remarks = l.Remarks;
    this.CurrentEditCounsellingActivityRequest.PlanCode = l.PlanCode;
    this.CurrentEditCounsellingActivityRequest.ActorCode = l.ActorCode;
    this.CurrentEditCounsellingActivityRequest.CounsellingActivityCode = l.CounsellingActivityCode;
    this.CurrentEditCounsellingActivityRequest.CreatedUser = l.CreatedUser;
    this.CurrentEditCounsellingActivityRequest.AssignedToName = l.AssignedToName;
    const modalRef = this.modalService.open(NgbEditActivityMonitoring2Modal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.CurrentEditCounsellingActivityRequest = this.CurrentEditCounsellingActivityRequest;
    modalRef.componentInstance.ADate = l.ActivityDate;
    modalRef.componentInstance.Time = l.ActivityTime;
    modalRef.componentInstance.AtrCode = l.ActorCode;
    modalRef.componentInstance.Code = l.PlanCode;
    modalRef.componentInstance.Name = l.DisplayName;
    modalRef.componentInstance.CreatedUserName = l.CreatedUser;
    modalRef.componentInstance.AssignedToName = l.AssignedToName;
    modalRef.result.then(x => { this.GetCounsellingActivitiesByTimeController() })
  }

  DeleteActivity(l: CounsellingActivitiesByTimeController) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActivity2(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActivity2(l: CounsellingActivitiesByTimeController) {
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var saveReq: GenericParams = new GenericParams();
    saveReq.ConditionalOperator = 40230;
    saveReq.Params = [
      new FTV('ActivityCode', 'number', l.CounsellingActivityCode)
    ];
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40230;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            //this.LoadAdmissionServices();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  DecrementDate(Value: any) {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
      //console.log('this.SelectedFromDate' + this.SelectedFromDate.month + "M" + this.SelectedFromDate.day)
      var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
        monthNo-1,
      this.SelectedFromDate.day
    );
      //this.parserFormatter.parse(this.SelectedFromDate).;
      //console.log('this.d' +  '-' + 'year:'+ d.getFullYear()+' month:'+ d.getMonth()+' day:'+ d.getDate())
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
//    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };
      //console.log('this.d1' + '-' + 'year:' + d.getFullYear() + ' month:' + d.getMonth()+1 + ' day:' + d.getDate())
  //  this.SelectedFromDate = this.SelectedFromDate.
      this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth()+1, day: d.getDate() };
      //console.log('this.SelectedFromDate1' + this.SelectedFromDate.month + "M" + this.SelectedFromDate.day)
    this.RefreshPatientsByDate();
    //ind++;
  }
  IncrementDate(Value: any) {
      //this.dateI = new Date();
      //var i = this.dateI.valueOf() + 86400000;
      //this.dateI = new Date(i);
      //this.SelectedFromDate = dateI;
      //var ind: number = 0;
      //this.diff = this.diff - 1;
      //alert(this.diff);
      var monthNo = this.SelectedFromDate.month
      var d: Date = new Date(
        this.SelectedFromDate.year,
          monthNo-1,
        this.SelectedFromDate.day
      );
      //this.parserFormatter.parse(this.SelectedFromDate).;

      d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
      //    d.getFullYear
      //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

      //  this.SelectedFromDate = this.SelectedFromDate.
      this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth()+1, day: d.getDate() };
      this.RefreshPatientsByDate();
      //ind++;
  }

  printactivity() {
    this.printService.printDocument("activitytrackingPV",
      {
        SelectedFromDate: this.SelectedFromDate, SelectedToDate: this.SelectedToDate, Day: this.SelectedFromDate.day, year: this.SelectedFromDate.year, month: this.SelectedFromDate.month
       }
    );
  }

}

